(function($) {
    'use strict';

    $.fn.clubPartnersPopup = function () {
        const $self = $(this);
        const $template = $($self.find('.hidden').first().contents());

        const init = function () {
            $self.on('click', '.js-club-partners-more', function (e) {
                e.preventDefault();

                $.magnificPopup.open({
                    items: {
                        src: $template.clone(),
                        type: 'inline'
                    },
                    mainClass: 'popup--club-partners',
                    closeMarkup: '<button class="popup-close" type="button"></button>',
                    preloader: false,
                    callbacks: {
                        open: function() {
                            SVK.makeFixedHtml();
                        },
                        close: function() {
                            SVK.makeUnfixedHtml();
                        }
                    }
                });
            });
        };

        init();

        return this;
    };

    document.addEventListener('DOMContentLoaded', function () {
        $('.js-club-partners-item').each(function () {
            $(this).clubPartnersPopup();
        });
    });
})(jQuery);
